const STATS_TIMERANGE = "1y";

export default function createPreferenceObject(asset, Confidence) {
    if (!Object.prototype.hasOwnProperty.call(asset, "assetType") || !Object.prototype.hasOwnProperty.call(asset, "assetID")) {
        return;
    }

    let score;

    if (asset.statsInfo && asset.statsInfo[STATS_TIMERANGE]) {
        score = asset.statsInfo[STATS_TIMERANGE].score;
    }

    if (!score) {
        return;
    }

    return {
        id: asset.assetID,
        derivedScore: score * Confidence,
        type: asset.assetType,
    };
}
